import { Panel } from "@poseidon/ui/components";
import List from "@mui/material/List";
import { ListItem } from "@mui/material";
import ListItemButton from "@mui/material/ListItemButton";
import { Link } from "react-router-dom";
import { WithDoc } from "@poseidon/firebase/components/WithDoc";
import { doc } from "firebase/firestore";
import { db } from "@poseidon/firebase";
import ListItemText from "@mui/material/ListItemText";

export function SailorLocksSummary({ sailor }) {
  const locks = [
    ...(sailor.lock_personalDetails_applications ?? []),
    ...(sailor.lock_sailor_applications ?? []),
  ].filter((ref, idx, refs) => refs.indexOf(ref) === idx);
  return (
    <Panel title="Sailor Locks">
      {locks.length > 0 ? (
        <>
          Sailor is locked by the following applications:
          <List>
            {locks.map((lock) => (
              <ListItem disablePadding key={lock}>
                <ListItemButton component={Link} to={`/applications/${lock}`}>
                  <WithDoc
                    docRef={doc(db, "applications", lock)}
                    Component={({ data }) => (
                      <ListItemText primary={data.applicationNumber} />
                    )}
                  />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </>
      ) : (
        "Sailor is not locked"
      )}
    </Panel>
  );
}
